/* =============================================================================
   THE EN MESSAGE CATALOGUE — GENERATED. DO NOT EDIT.

   Generated by _UIUpgrade\tools\message-catalog-generate.node.mjs from
   _UIUpgrade\message-standardisation\messages.master.json (D1, the neutral
   master). Change a wording THERE and re-run the generator — an edit made
   here is reverted by the next run, silently.

   This is the PRODUCT message dictionary: every entry is an OBJECT (ruling
   D3) carrying the text, the severity and the appearance the message is
   shown with, so a call site names a key and nothing else:
     IcsMsg('validation.selectItemS')
     IcsMsg('validation.selectItemS', { what: 'a buyer' })

   It is deliberately a SEPARATE file from the hand-authored en.js, which
   keeps the component strings a person maintains. localisation-map.js
   merges the two; on a key present in both, THIS file loses (the hand
   catalogue is the component contract) — and the generator refuses to
   emit such a key at all, so the case should never arise.

   ENTRY SHAPE
     text            the sentence, with {named} slots
     tokens          per-slot DEFAULTS — a default renders the owner-approved
                     sentence byte-for-byte, so a caller passing nothing gets
                     exactly what was approved; a token only ADDS capability
     requiredTokens  slots with NO sensible default: the caller must supply
                     them, and an unsupplied one stays visible as {slot}
                     rather than collapsing the sentence to nonsense
     severity        error | warning | success | info | question
     appearance      toast | modal | confirm | prompt  (ruling D4: toast-first,
                     modal ONLY for a refused click)
     title           null = the appearance's own default title

   Master generated: 2026-09-05 16:41   ·   92 keys
   ============================================================================= */
export default {

  /* ---- confirm ---- */
  'confirm.confirm': {
    text: 'Confirm to {action}?',
    requiredTokens: ['action'],
    severity: 'question',
    appearance: 'confirm',
  },
  'confirm.confirmActivate': { text: 'Confirm to Activate?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmApprove': { text: 'Confirm to Approve?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmChangeOrderReviseNo': {
    text: 'Confirm to change this order with revise no?',
    severity: 'question',
    appearance: 'confirm',
  },
  'confirm.confirmChangeOrderWithoutRevise': {
    text: 'Confirm to change this order without revise no?',
    severity: 'question',
    appearance: 'confirm',
  },
  'confirm.confirmCopy': { text: 'Confirm to copy?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmDeactivate': { text: 'Confirm to Deactivate?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmDelete': { text: 'Confirm to Delete?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmDisburse': { text: 'Confirm to disburse?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmReceive': { text: 'Confirm to Receive?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmUndoApprove': { text: 'Confirm to Undo Approve?', severity: 'question', appearance: 'confirm' },
  'confirm.confirmUndoRequest': { text: 'Confirm to undo request?', severity: 'question', appearance: 'confirm' },

  /* ---- empty ---- */
  'empty.dataItemsNotFound': {
    text: '{what} not found.',
    tokens: { what: 'Data/Items' },
    severity: 'info',
    appearance: 'toast',
  },
  'empty.fileNotFound': { text: 'File not found.', severity: 'info', appearance: 'toast' },

  /* ---- error ---- */
  'error.error': { text: 'Error: {detail}.', requiredTokens: ['detail'], severity: 'error', appearance: 'toast' },
  'error.failedGetPiprintsetup': { text: 'Failed to get PIPrintSetup.', severity: 'error', appearance: 'toast' },
  'error.failedGetPitandcclause': { text: 'Failed to get PITandCClause.', severity: 'error', appearance: 'toast' },
  'error.fileNotSupported': { text: 'File not supported.', severity: 'error', appearance: 'toast' },
  'error.formdataNotSupported': { text: 'FormData is not supported.', severity: 'error', appearance: 'modal' },
  'error.noResponseServer': { text: 'No response from server.', severity: 'error', appearance: 'toast' },

  /* ---- notice ---- */
  'notice.noItemsFoundTwisted': { text: 'No items found to be twisted.', severity: 'info', appearance: 'toast' },

  /* ---- success ---- */
  'success.approvedSuccessfully': { text: 'Approved successfully.', severity: 'success', appearance: 'toast' },
  'success.deletedSuccessfully': { text: 'Deleted successfully.', severity: 'success', appearance: 'toast' },
  'success.processSuccessfully': { text: 'Process successfully.', severity: 'success', appearance: 'toast' },
  'success.receivedSuccessfully': { text: 'Received successfully.', severity: 'success', appearance: 'toast' },
  'success.savedSuccessfully': { text: 'Saved successfully.', severity: 'success', appearance: 'toast' },
  'success.successfullyReceived': { text: 'Successfully received.', severity: 'success', appearance: 'toast' },
  'success.undoApproveSuccessfully': { text: 'Undo Approve successfully.', severity: 'success', appearance: 'toast' },

  /* ---- validation ---- */
  'validation.addAtLeastOneDetail': { text: 'Add at least one detail.', severity: 'warning', appearance: 'toast' },
  'validation.alreadyDisbursed': { text: 'Already disbursed.', severity: 'warning', appearance: 'toast' },
  'validation.alreadyReceived': { text: 'Already received.', severity: 'warning', appearance: 'toast' },
  'validation.checkDateSelectionStartDate': {
    text: 'Check Date selection or Start-Date End-date range.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.enterAtLeast4Character': {
    text: 'Enter at least 4 character to search.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.enterAtLeastOneField': { text: 'Enter at least one field.', severity: 'warning', appearance: 'toast' },
  'validation.enterInvoiceStartAmount': {
    text: 'Enter invoice start Amount.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.enterNameCodeSearch': {
    text: 'Enter name or code to search.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.enterPhoneNumber': { text: 'Enter phone number.', severity: 'warning', appearance: 'toast' },
  'validation.enterPiStartAmount': { text: 'Enter PI start amount.', severity: 'warning', appearance: 'toast' },
  'validation.enterValidRange': { text: 'Enter valid range.', severity: 'warning', appearance: 'toast' },
  'validation.firstSaveOrder': { text: 'First, save order.', severity: 'warning', appearance: 'toast' },
  'validation.invalidOperation': { text: 'Invalid operation.', severity: 'warning', appearance: 'toast' },
  'validation.pickDelivery': { text: 'Pick a delivery to.', severity: 'warning', appearance: 'toast' },
  'validation.productRequired': { text: 'Product required.', severity: 'warning', appearance: 'toast' },
  'validation.searchConditionCriteria': {
    text: 'Search with condition/criteria.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.searchFabricType': { text: 'Search with fabric type.', severity: 'warning', appearance: 'toast' },
  'validation.searchFirst': { text: 'Search first.', severity: 'warning', appearance: 'toast' },
  'validation.selectAccountHead': { text: 'Select account head.', severity: 'warning', appearance: 'toast' },
  'validation.selectApprovedItemS': { text: 'Select Approved item(s).', severity: 'warning', appearance: 'toast' },
  'validation.selectBankBranch': { text: 'Select a bank branch.', severity: 'warning', appearance: 'toast' },
  'validation.selectBusinessUnit': { text: 'Select a Business Unit.', severity: 'warning', appearance: 'toast' },
  'validation.selectColor': { text: 'Select color.', severity: 'warning', appearance: 'toast' },
  'validation.selectContractor': {
    text: 'Select a {what}.',
    tokens: { what: 'contractor' },
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectCurrency': { text: 'Select currency.', severity: 'warning', appearance: 'toast' },
  'validation.selectCustomer': {
    text: 'Select {what}.',
    tokens: { what: 'customer' },
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectDelivery': { text: 'Select delivery to.', severity: 'warning', appearance: 'toast' },
  'validation.selectDepartment': { text: 'Select a department.', severity: 'warning', appearance: 'toast' },
  'validation.selectDesignation': { text: 'Select a designation.', severity: 'warning', appearance: 'toast' },
  'validation.selectedItemAlreadyReceived': {
    text: 'Selected item is already Received.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectedItemCanceled': { text: 'Selected item is canceled.', severity: 'warning', appearance: 'toast' },
  'validation.selectEmployee': { text: 'Select an employee.', severity: 'warning', appearance: 'toast' },
  'validation.selectEmployeeGroup': { text: 'Select an employee group.', severity: 'warning', appearance: 'toast' },
  'validation.selectEmployeeType': { text: 'Select an employee type.', severity: 'warning', appearance: 'toast' },
  'validation.selectItemS': {
    text: 'Select {what}.',
    tokens: { what: 'item(s)' },
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectItemSEnterField': {
    text: 'Select {what} / enter field(s) value.',
    tokens: { what: 'item(s)' },
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectLocation': { text: 'Select a location.', severity: 'warning', appearance: 'toast' },
  'validation.selectLot': { text: 'Select lot.', severity: 'warning', appearance: 'toast' },
  'validation.selectMachine': { text: 'Select machine.', severity: 'warning', appearance: 'toast' },
  'validation.selectMarketingPerson': { text: 'Select marketing person.', severity: 'warning', appearance: 'toast' },
  'validation.selectMonth': { text: 'Select a month.', severity: 'warning', appearance: 'toast' },
  'validation.selectNotApprovedItemS': {
    text: 'Select \'Not Approved\' item(s).',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectOneItem': { text: 'Select one item.', severity: 'warning', appearance: 'toast' },
  'validation.selectOneRefType': { text: 'Select one Ref Type.', severity: 'warning', appearance: 'toast' },
  'validation.selectOnlyInitializedItemList': {
    text: 'Select only Initialized item from the list.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectOnlyInitializedItemS': {
    text: 'Select Only Initialized item(s).',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectOnlyRequestedItemList': {
    text: 'Select only Requested item from the list.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.selectOrder': { text: 'Select order.', severity: 'warning', appearance: 'toast' },
  'validation.selectPaymentType': { text: 'Select payment type.', severity: 'warning', appearance: 'toast' },
  'validation.selectProcess': { text: 'Select process.', severity: 'warning', appearance: 'toast' },
  'validation.selectRefType': { text: 'Select Ref Type.', severity: 'warning', appearance: 'toast' },
  'validation.selectReportLayout': { text: 'Select a report layout.', severity: 'warning', appearance: 'toast' },
  'validation.selectSchema': { text: 'Select a schema.', severity: 'warning', appearance: 'toast' },
  'validation.selectSection': { text: 'Select a Section.', severity: 'warning', appearance: 'toast' },
  'validation.selectShift': { text: 'Select a shift.', severity: 'warning', appearance: 'toast' },
  'validation.selectStatus': { text: 'Select status.', severity: 'warning', appearance: 'toast' },
  'validation.selectStore': { text: 'Select store.', severity: 'warning', appearance: 'toast' },
  'validation.selectStyle': { text: 'Select style.', severity: 'warning', appearance: 'toast' },
  'validation.selectType': { text: 'Select type.', severity: 'warning', appearance: 'toast' },
  'validation.selectUnit': { text: 'Select unit.', severity: 'warning', appearance: 'toast' },
  'validation.selectYear': { text: 'Select a year.', severity: 'warning', appearance: 'toast' },
  'validation.startAmountMustSmallerThan': {
    text: 'Start amount must be smaller than end amount.',
    severity: 'warning',
    appearance: 'toast',
  },
  'validation.typeColorName': { text: 'Type color name.', severity: 'warning', appearance: 'toast' },
  'validation.typeThenPressEnter': { text: 'Type then press enter.', severity: 'warning', appearance: 'toast' },
};
